/* globals lp, jui, rxSwitchboard */
var _ = require('lodash');

lp.editor.panel = lp.editor.panel || {};
lp.editor.panel.ElementGeometryControls = {
  createGeometryListeners: function() {
    var self = this;
    this.modelChangeHandlers.push(function(e) {
      var accessor = e.data.accessor;
      var value = e.data.value;

      if (accessor.startsWith('geometry')) {
        self.applyGeometry(accessor, value);
      }
    });
  },

  _mkOnARChangeHandler: function(action) {
    var self = this;
    return function(juiEvent) {
      self._geometryUIBinding.onNext({
        type      : action,
        elementId : self.element.id,
        maintainAR : juiEvent.data
      });
    };
  },

  _mkOnOffsetChangeHandler: function(action) {
    var self = this;
    var _offsetChanged = function(juiEvent) {
      var oldOffset = juiEvent.data.memorizedValues;
      return juiEvent.data.top.getValue() !== oldOffset.top ||
        juiEvent.data.left.getValue() !== oldOffset.left;
    };

    return function(juiEvent) {
      if(_offsetChanged(juiEvent)) {
        self._geometryUIBinding.onNext({
          type      : action,
          elementId : self.element.id,
          offset: {
            top  : _.parseInt(juiEvent.data.top.getValue()),
            left : _.parseInt(juiEvent.data.left.getValue())
          }
        });
      }
    };
  },

  _mkOnScaleChangeHandler: function(action) {
    var self = this;
    return function(juiEvent) {
      self._geometryUIBinding.onNext({
        type      : action,
        elementId : self.element.id,
        scale     : _.parseInt(juiEvent.data)
      });
    };
  },


  _mkOnSizeChangeHandler: function(action) {
    var self = this;
    var _sizeChanged = function(juiEvent) {
      var oldSize = juiEvent.data.memorizedSize;
      var width = juiEvent.data.width;
      var height = juiEvent.data.height;
      return (width && width.getValue() !== oldSize.width) ||
        (height && height.getValue() !== oldSize.height);
    };

    var _getSizeFromEvent = function(juiEvent) {

      var widthField  = juiEvent.data.width
        , heightField = juiEvent.data.height;

      return {
        width  : widthField ? _.parseInt(widthField.getValue()) : undefined,
        height : heightField ? _.parseInt(heightField.getValue()) : undefined
      };
    };

    return function(juiEvent) {
      if(juiEvent.data.width && _sizeChanged(juiEvent)) {
        self._geometryUIBinding.onNext({
          type      : action,
          elementId : self.element.id,
          size: _getSizeFromEvent(juiEvent)
        });
      }

    };
  },

  _geometryControlUIEventHandlers: {
    changeScale: function(ev, model, um){
        model.setScale(ev.scale / 100, um);
    },

    changeSize: function(ev, model, um){
        model.setSize(ev.size, um);
    },

    changeOffset: function(ev, model, um) {
      var offset = ev.offset;
      var position = model.exists('geometry.position') ?
        model.get('geometry.position') : 'absolute';
      model.setOffset(
        (position === 'absolute'? offset : {left:0,top:0}), um);
    },

    changeMaintainAR: function(ev, model, um) {
      model.set('geometry.maintainAR', ev.maintainAR, um);
    }
  },

  hasVisiblityToggle: function() {
    return window.editor.page.getConfigValue('allowVisibilityToggle');
  },

  installGeometryControls: function(options) {
    this._geometryUIBinding = this._uiBinding.mkNamespacedVersion('geometry');

    this.createGeometryListeners();

    options.insert = options.insert || this.insert.bind(this);
    options.focus = options.focus || this.requestFocus.bind(this);
    options.sizeOptions = options.sizeOptions || {};

    var self = this;

    // TODO: replace with dispatch table passed to _mkUIBinding above
    this._geometryUIBinding
      .sink
      .filter(function(ev){
        return _.has(self._geometryControlUIEventHandlers, ev.type);
      })
      .ub_subscribe(function(ev){
        var action = ev.type;
        var handler = self._geometryControlUIEventHandlers[action];
        var um = self.element.page.undoManager;
        um.startGroup('updateGeometry');
        self.performModelUpdates(function () {
          if (ev.elementId  === self.element.id) {
            handler(ev, self.element.model, um);
          } else {
            var e = new TypeError('The element from the event and active element are not the same.');
            window.editor.reportError({
              error: e,
              id: window.editor.mainPage.id,
              message: "Element mis-match.  event element: " + ev.elementId + " active element " + self.element.id,
              details: "Element mis-match",
              userAgent: window.navigator.userAgent
            });
          }
        });
        um.endGroup();
    });


    this.controls.size = options.insert( new jui.FormSizeInput(Object.extend({
      onblur: self._mkOnSizeChangeHandler('changeSize'),
      onfocus: options.focus,
      onmaintainARChange: self._mkOnARChangeHandler('changeMaintainAR')
    }, options.sizeOptions)));

    this.controls.offset = options.insert( new jui.FormOffsetInput({
      onblur: self._mkOnOffsetChangeHandler('changeOffset'),
      onfocus: options.focus
    }));


    var undoManager = window.editor.page.undoManager;
    this.controls.scale = options.insert(new jui.FormSliderInput({
      label:'Scale',
      onchange: self._mkOnScaleChangeHandler('changeScale'),
      onfocus: function(e){
        self.requestFocus(e);
      },
      startTracking: function() {
        undoManager.startGroup();
      },
      stopTracking: function() {
        undoManager.endGroup();
      },
      slider:{
        min       : 50,
        max       : 150,
        increment : 1
      }
    }));

    if (!this.hasVisiblityToggle()) {
      return;
    }

    // TODO: Look into removing this. It's currently hidden by css and doesn't seem to be needed any longer.
    // when we try to remove it the actual functional button visibleToggleIcon gets removed at when switching
    // the active element
    this.controls.visible = options.insert(new jui.FormCheckboxInput({
      label:'Visible',
      onclick: function(e) {
        self.element.model.setVisible(e.data, undoManager);
        self.element.page.updateAndRefresh();
      }
    }));

    var visibilityToggle = this.controls.visible.e;
    var panel = visibilityToggle.closest('.element-properties-panel');

    var visibleToggleIcon = document.createElement('div');
    visibleToggleIcon.className = 'visibility-toggle';
    visibleToggleIcon.innerHTML = '<span>Visibility</span>' +
      '<span class="visibility-state svg-ico-eye-opened"></span>';

    this.msgPanel = document.createElement('div');
    this.msgPanel.className = 'collapsible-panel visibility-toggle-message';
    this.msgPanel.innerHTML = '<p class="panel-content clearfix">' +
      '<strong>Hint:</strong> ' +
      'Use the "Page Contents" button in the bottom left ' +
      'to find the invisible elements and make them visible again.' +
      '</p>';

    visibilityToggle.classList.add('visibility-toggle-hidden');

    panel.appendChild(visibleToggleIcon);

    var panelContainer = panel.querySelector('.content > .collapsible-panel').parentNode;
    panelContainer.insertBefore(this.msgPanel, panelContainer.querySelector('.collapsible-panel'));

    this._uiBinding.bindDOM(visibleToggleIcon, 'click', 'toggleElementVisibility')
      .ub_subscribe(function () {
        rxSwitchboard.fireUIEvent({
          elementId: self.element.id,
          type: 'toggleVisibility',
          domTarget: 'element-panel'
        });
      });
  },

  bindGeometryControlsToElement: function(elm) {
    var m = elm.model;
    // JS: TODO: settinf default values into the controls will cause these defaults to be saved with the element
    // even if they are not needed.. this should be changed somehow

    this.controls.offset.setValue(m.getOffset());
    this.controls.size.setValue(m.getSize());

    var maxSize = m.getMaxSize();
    var minSize = m.getMinSize();

    this.controls.size.options.maxWidth = maxSize.width;
    this.controls.size.options.maxHeight = maxSize.height;

    this.controls.size.options.minWidth = minSize.width;
    this.controls.size.options.minHeight = minSize.height;

    this.controls.scale.setValue(m.getScale() * 100);

    this.controls.scale.setVisible(elm.is('scalable') && !elm.page.isDefaultBreakpoint());

    if (this.hasVisiblityToggle()) {
      // visibility control
      this.controls.visible.setValue(m.isVisible());
      document.querySelectorAll('.element-properties-panel .visibility-toggle .visibility-state')
        .forEach(e => e.classList.toggle('lp-hidden', !m.isVisible()));
      document.querySelectorAll('.content .visibility-toggle-message')
        .forEach(e => e.classList.toggle('closed', m.isVisible()));
    }

    if (elm.type === 'lp-multi-select') {
      document.querySelectorAll('.element-properties-panel .visibility-toggle')
        .forEach(e => e.style.display = 'none');
    }

    this.controls.offset.setVisible(elm.is('offsetable'));
  },


  applyGeometry: function(accessor, value){
    var m = this.element.model;
    if (accessor.startsWith('geometry.offset')) {
      this.controls.offset.setValue(m.getOffset());
    } else if (accessor.startsWith('geometry.size')) {
      this.controls.size.setValue(m.exists('geometry.size') ? m.get('geometry.size') : {width:'',height:''});
    } else if (accessor.startsWith('geometry.maxSize')) {
      this.controls.size.options.maxWidth = value.width;
      this.controls.size.options.maxHeight = value.height;
    } else if (accessor.startsWith('geometry.minSize')) {
      this.controls.size.options.minWidth = value.width;
      this.controls.size.options.minHeight = value.height;
    } else if (accessor.startsWith('geometry.scale')) {
      var percentage = Math.round(( value ? value : 1 ) * 100);
      this.controls.scale.setValue(percentage);
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/panel/element_geometry_controls.js
// module id = 1040
// module chunks = 0